// extracted by mini-css-extract-plugin
export default {"pagination":"Users_pagination__vKtr3","page-item":"Users_page-item__N0iOj","page-link":"Users_page-link__eyo+9","active":"Users_active__W8h+C","disabled":"Users_disabled__mL3Jy"};